/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["app-payslip-icon .Icon--Payslip--hide{display:none}@media (min-width:1440px){app-payslip-icon .Icon--Payslip--hide{display:inherit}}app-payslip-icon .Icon--error,app-payslip-icon .Icon--warning{height:1.5rem;width:1.5rem}"];
export { styles as styles };
